import Swiper, { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper';

Swiper.use([Navigation, Pagination, Scrollbar, Autoplay]);

export default function FourStage() {
  const stageAtribute = {
    direction: 'horizontal',
    loop: false,
    spaceBetween: 60,
    autoHeight: true,
    preloadImages: false,
    draggable: true,
    freeMode: {
      enabled: false,
      sticky: false,
    },
    pagination: {
      el: '.four-stage .swiper-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        return '<div class="pagination-dot ' + className + '"></div>';
      },
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
    },
  };

  let isFourStageInit = false;
  if (window.innerWidth <= 767) {
    const FourStage = new Swiper('.four-stage .swiper', stageAtribute);

    isFourStageInit = true;
  }

  const containerStage = document.querySelector('.four-stage');
  const FourStagePagination = document.querySelector('.four-stage .swiper-pagination');

  window.addEventListener('resize', (event) => {
    if (containerStage && (window.innerWidth > 767) && isFourStageInit) {
      const FourStage1 = containerStage.querySelector('.swiper').swiper;
      if (FourStage1) {
        FourStage1.pagination.destroy();
        FourStagePagination.innerHTML = '';
        FourStage1.destroy(true, true);
        isFourStageInit = false;
        containerStage.querySelector('.swiper-wrapper').style = '';
        containerStage.querySelector('.swiper-slide').style = '';
      }
    } else if (containerStage && (window.innerWidth <= 767) && !isFourStageInit) {
      isFourStageInit = true;

      const FourStage2 = new Swiper('.four-stage .swiper', stageAtribute);
    }
  });
}
